/**
 * App badge counts — EMPTY in this build.
 *
 * Badge counts (unread messages, pending reminders, etc.) were backend-driven.
 * With no backend there are no badges, so this always returns an empty map.
 * Kept at the original import path so `GroupOverlay` (and any future consumer)
 * compiles unchanged and simply renders no badges.
 */
export function useAppBadgeCounts(): Map<string, number> {
  return EMPTY;
}

const EMPTY: Map<string, number> = new Map();
